import { Props } from './types';
import { ChoiceChip as StyledChoiceChip } from './ChoiceChip.styled';

export function ChoiceChip({ label = '', isActive = false, onClick, ...props }: Props) {
  const onChipClick = () => {
    if (onClick) {
      onClick(isActive);
    }
  };

  return (
    <StyledChoiceChip isActive={isActive} label={label} onClick={onChipClick} variant="outlined" {...props} />
  );
}
